












import {
  defineComponent,
  onMounted,
  onUnmounted,
} from '@nuxtjs/composition-api'
import { v4 as guid } from 'uuid'
import { IFrameOutput } from '@/contracts/IFrame'

export default defineComponent({
  props: {
    name: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    emitDelay: {
      type: Number,
      default: 300,
    },
    sameOrigin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, refs }) {
    let interval
    const id = guid()
    const emitData = (iframe: HTMLIFrameElement) => {
      const iframeData = {
        url: iframe.contentWindow.location.href,
        hostname: iframe.contentWindow.location.hostname,
        document: iframe.contentDocument,
      } as IFrameOutput
      emit('update', iframeData)
    }

    onMounted(() => {
      if (process.browser && props.sameOrigin) {
        document.domain = (() => {
          const arr = window.location.hostname.split('.')
          return `${arr[arr.length - 2]}.${arr[arr.length - 1]}`
        })()
        const intervalCallback = () => {
          try {
            emitData(refs.iframe)
          } catch (e) {
            // eslint-disable-next-line no-console
            console.info('Iframe data emitting stopped', e)
            clearInterval(interval)
            emit('stop')
          }
        }

        refs.iframe.onload = () => {
          emit('load')
          interval = setInterval(intervalCallback, props.emitDelay)
        }
      }
    })

    onUnmounted(() => {
      clearInterval(interval)
    })

    return {
      id,
    }
  },
})
